import { useBooking } from "@/context/BookingContext";
import { Gamepad2 } from "lucide-react";

export default function StickyBookCTA() {
  const { openBooking } = useBooking();
  return (
    <div
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 px-3 pt-3 bg-[#0A0A0A]/95 backdrop-blur-md border-t border-rgv-darkred"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
      data-testid="sticky-book-bar"
    >
      <button
        onClick={() => openBooking()}
        data-testid="sticky-book-btn"
        className="btn-skew btn-red w-full py-3.5 text-lg min-h-[48px]"
      >
        <span className="flex items-center gap-2">
          <Gamepad2 className="h-5 w-5" /> Book Your Party
        </span>
      </button>
    </div>
  );
}
